import React, { useEffect, useState } from "react";
import ReactModal from "react-modal";
import { useSearchParams } from "react-router-dom";
import AdminVerificationSuccess from "../components/AdminVerificationSuccess/AdminVerificationSuccess";
import AdminVerificationFailed from "../components/AdminVerificationFailed/AdminVerificationFailed";
import { isMobile } from "../Utils";
import { APP_REDIRECT_MESSAGE } from "../CONSTANTS"

const customStyles = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        border: "none",
        padding: "0",
    },
};

function AdminEmailVerification() {
    const [error, setError] = useState("");
    const [success, setSuccess] = useState(false);
    const [message, setMessage] = useState("");
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const status = searchParams.get("status");
        const statusMessage = searchParams.get("message");
        const type = searchParams.get("type");
        if (type === "customer" && isMobile()) {
            document.location.href = `${APP_REDIRECT_MESSAGE}${statusMessage}`;
        }
        if (status === "success") {
            setSuccess(true);
            setMessage(statusMessage || "Admin email verified successfully.");
        } else if (status === "error") {
            setError(statusMessage || "Email verification failed.");
        } else {
            // If no status is provided, assume error with missing parameters
            setError("Missing verification parameters or invalid link.");
        }
    }, [searchParams]);

    return (
        <div>
            <ReactModal isOpen={!!error} style={customStyles}>
                <AdminVerificationFailed message={error} />
            </ReactModal>
            <ReactModal isOpen={success} style={customStyles}>
                <AdminVerificationSuccess message={message} />
            </ReactModal>
        </div>
    );
}

export default AdminEmailVerification; 